export default "__VITE_ASSET__DfvOdxF5__"